import { render, staticRenderFns } from "./PetitionerGuide.vue?vue&type=template&id=0faf4778"
import script from "./PetitionerGuide.vue?vue&type=script&lang=js"
export * from "./PetitionerGuide.vue?vue&type=script&lang=js"
import style0 from "./PetitionerGuide.vue?vue&type=style&index=0&id=0faf4778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports